import { gql } from '@apollo/client';

export const GET_IS_USER_LOGGED_IN = gql`
  query GetIsUserLoggedIn {
    user @client {
      isLoggedIn
    }
  }
`;
